import { FieldAPI } from '@philips-internal/oswald-ui-components';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { BaseValidatorOptions, Validator } from '@philips-internal/oswald-ui-core/lib/services/model-service';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';
import { INSURANCE_CATEGORY_VISIBILITY, INSURANCE_VISIBILITY } from '../constants/field-visibility';
import { VisibilityFieldsResponse } from '../controllers/pseudonym-appointments/pseudonym-interfaces';

export const InsuranceFields = {
  required
}

export interface InsuranceFieldVisibility {
  isCategoryRequired: boolean;
  isCategoryVisible: boolean;
  isHealthCardNumberRequired: boolean;
  isPlanRequired: boolean;
  isPlanVisible: boolean;
}

interface InsuranceFieldTargets {
  categoryField?: FieldAPI;
  healthCardNumberField?: FieldAPI;
  planField?: FieldAPI;
}

function required(options?: BaseValidatorOptions): Validator {
  return {
    name: 'required',
    options,
  }
}

export function getInsuranceFieldVisibility(): Promise<InsuranceFieldVisibility> {
  return HttpService.get(APPLICATION_ENDPOINTS.GET_VISIBILITY_OF_FIELDS)
    .then((response) => {
      const mandatoryFields = response.body as VisibilityFieldsResponse;

      return {
        isCategoryRequired: mandatoryFields.insuranceCategory === INSURANCE_CATEGORY_VISIBILITY.MANDATORY,
        isCategoryVisible: mandatoryFields.insuranceCategory !== INSURANCE_CATEGORY_VISIBILITY.NOT_VISIBLE,
        isHealthCardNumberRequired: mandatoryFields.insuranceCardNumber === INSURANCE_VISIBILITY.MANDATORY,
        isPlanRequired: mandatoryFields.insurancePlan === INSURANCE_VISIBILITY.MANDATORY,
        isPlanVisible: mandatoryFields.insurancePlan !== INSURANCE_VISIBILITY.NOT_VISIBLE,
      };
    });
}

export function applyInsuranceFieldVisibility(fields: InsuranceFieldTargets, visibility: InsuranceFieldVisibility): void {
  if (fields.categoryField) {
    fields.categoryField.setVisible(visibility.isCategoryVisible);
    if (visibility.isCategoryRequired) {
      fields.categoryField.setValidators([InsuranceFields.required]);
    }
  }

  if (fields.planField) {
    fields.planField.setVisible(visibility.isPlanVisible);
    if (visibility.isPlanRequired) {
      fields.planField.setValidators([InsuranceFields.required]);
    }
  }

  if (fields.healthCardNumberField && visibility.isHealthCardNumberRequired) {
    fields.healthCardNumberField.setValidators([InsuranceFields.required]);
  }
}
